import Hero from './components/Hero';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Stats from './components/Stats';
import FAQ from './components/FAQ';
import CTA from './components/CTA';
import PageSEO from '@/components/base/PageSEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import { features, workflowSteps, stats, faqList } from '@/mocks/data';

export default function Home() {
  return (
    <>
      <PageSEO
        title="一起草视频-视频协作创作平台 | 多人实时共同编辑、草稿管理与一键发布"
        description="一起草视频是专为内容创作者、团队和品牌打造的视频协作创作平台，支持多人实时共同编辑、草稿管理与一键发布，让你的一起草视频体验更高效、更流畅，告别单打独斗，开启团队创作新模式。"
        canonicalPath="/"
      />
      <SchemaOrg type="WebPage" data={{
        name: '一起草视频 - 首页',
        url: 'https://spiritualhealing.cn',
        description: '专为内容创作者、团队和品牌打造的视频协作创作平台',
        isPartOf: { '@type': 'WebSite', name: '一起草视频', url: 'https://spiritualhealing.cn' },
      }} />
      <SchemaOrg type="FAQPage" data={{
        mainEntity: faqList.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      }} />
      <Hero />
      <Features features={features} />
      <HowItWorks steps={workflowSteps} />
      <Stats stats={stats} />
      <FAQ faqs={faqList} />
      <CTA />
    </>
  );
}